export default __webpack_public_path__ + "static/media/house-on-cliff.5029c9fb.jpg";